module.exports = __webpack_public_path__ + "static_pc/img/test1.98ba3ddc.jpg";